export const secretKey = "J84Qv2FqbMpkrqA&vPGzfm54NQ7mn4^x"
export const keyIV = secretKey.substring(0, 16)